import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { SoundProvider } from './contexts/SoundContext'
import { YouTubeShareProvider } from './contexts/YouTubeShareContext'
import './index.css'

// Automatic service worker update handling - user never has to do anything
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js')

      // Check for updates immediately and every 60 seconds
      registration.update()
      setInterval(() => registration.update(), 60000)

      // Handle waiting service worker (new version available)
      const handleWaiting = (worker) => {
        // Tell the waiting worker to take over immediately
        worker.postMessage({ type: 'SKIP_WAITING' })
      }

      // If there's already a waiting worker, activate it
      if (registration.waiting) {
        handleWaiting(registration.waiting)
      }

      // Listen for new service worker installations
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version installed while user has the page open
              handleWaiting(newWorker)
            }
          })
        }
      })

      // Auto-reload when new service worker takes control
      let refreshing = false
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true
          window.location.reload()
        }
      })
    } catch (err) {
      console.warn('SW registration failed:', err)
    }
  })
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SoundProvider>
      <YouTubeShareProvider>
        <App />
      </YouTubeShareProvider>
    </SoundProvider>
  </React.StrictMode>,
)
